var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter16 = function SvgTwitter16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#23024D",
    d: "M9.143 7.082 13.61 2h-1.059l-3.88 4.412L5.573 2H2l4.685 6.672L2 14h1.058l4.096-4.66L10.426 14H14M3.44 2.781h1.626l7.486 10.476h-1.627"
  })));
};
export default SvgTwitter16;